import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import ChangePassword from "../ChangePassword";
import MyPlan from "../Subscription";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import "./settings.css";

const SETTINGS_SECTIONS = {
  password: {
    label: "Password & security",
  },
  subscription: {
    label: "Subscription",
  },
};

const getSectionFromLocation = (pathname, searchParams) => {
  const requestedSection = searchParams.get("section");

  if (requestedSection === "subscription") {
    return "subscription";
  }

  if (requestedSection === "password") {
    return "password";
  }

  return pathname === "/user/subscription" || pathname === "/user/billing"
    ? "subscription"
    : "password";
};

const Settings = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeSection = getSectionFromLocation(location.pathname, searchParams);
  const activeSectionDetails = SETTINGS_SECTIONS[activeSection];

  const handleSectionChange = (section) => {
    setSearchParams({ section });
  };

  return (
    <main className="settings-page">
      <div className="settings-shell">
        <header className="settings-header dashboard-page-heading dashboard-page-heading--title-only">
          <h1 className="dashboard-page-title">Settings</h1>
        </header>

        <Tabs
          className="settings-toggle"
          onValueChange={handleSectionChange}
          value={activeSection}
          variant="underline"
        >
          <TabsList aria-label="Settings sections" className="settings-toggle-list">
            {Object.entries(SETTINGS_SECTIONS).map(([section, details]) => (
              <TabsTrigger key={section} value={section}>
                {details.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        <section
          aria-label={activeSectionDetails.label}
          className="settings-panel"
          id="settings-panel"
          role="tabpanel">
          {activeSection === "password" ? (
            <ChangePassword embedded />
          ) : (
            <MyPlan embedded />
          )}
        </section>
      </div>
    </main>
  );
};

export default Settings;
